import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const HelpDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Centre d'aide ERA</DialogTitle>
      <DialogContent dividers>
        <Typography paragraph>
          Bienvenue dans le centre d'aide. Voici les réponses aux questions les plus fréquentes.
        </Typography>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight="bold">Comment créer un nouveau projet ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              Depuis le tableau de bord, cliquez sur le bouton "+" ou "Nouveau Projet". Remplissez les détails et validez.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight="bold">Comment inviter des membres ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              Dans la vue détaillée d'un projet, cliquez sur l'icône "Paramètres" ou "Membres" pour ajouter des collaborateurs par email.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight="bold">Comment changer mon avatar ?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2">
              Allez dans le menu Profil &gt; Gérer le compte &gt; Informations personnelles.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Box sx={{ mt: 3, p: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
          <Typography variant="subtitle2" gutterBottom>Besoin de plus d'aide ?</Typography>
          <Typography variant="body2">
            Contactez le support technique à <a href="mailto:support@era.local">support@era.local</a>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  );
};

export const ShortcutsDialog = ({ open, onClose }) => {
  const shortcuts = [
    { key: 'Ctrl + K', action: 'Ouvrir la recherche rapide' },
    { key: 'Ctrl + /', action: 'Ouvrir ce menu de raccourcis' },
    { key: 'Esc', action: 'Fermer les modales et menus' },
    { key: 'Ctrl + Enter', action: 'Envoyer un message / Valider une tâche' },
    { key: '?', action: 'Ouvrir l\'aide' },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Raccourcis Clavier</DialogTitle>
      <DialogContent dividers>
        <Box component="ul" sx={{ pl: 2, m: 0 }}>
          {shortcuts.map((s, index) => (
            <Box component="li" key={index} sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
              <Typography variant="body2">{s.action}</Typography>
              <Box 
                component="span" 
                sx={{ 
                  bgcolor: 'action.selected', 
                  px: 1, 
                  py: 0.5, 
                  borderRadius: 1, 
                  fontFamily: 'monospace',
                  fontSize: '0.8rem',
                  fontWeight: 'bold'
                }}
              >
                {s.key}
              </Box>
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  );
};
